import { extractLogger } from "./logging/logger_factory";
import { extractErrorNotifier } from "./error/error_notifier_factory";
import { extractConfigManager } from "./project_config/config_manager_factory";
import { extractEventProcessor } from "./event_processor/event_processor_factory";
import { extractOdpManager } from "./odp/odp_manager_factory";
import { extractVuidManager } from "./vuid/vuid_manager_factory";
import { CLIENT_VERSION, DEFAULT_CMAB_BACKOFF_MS, DEFAULT_CMAB_CACHE_SIZE, DEFAULT_CMAB_CACHE_TIMEOUT_MS, DEFAULT_CMAB_RETRIES, JAVASCRIPT_CLIENT_ENGINE } from "./utils/enums";
import Optimizely from "./optimizely";
import { DefaultCmabClient } from "./core/decision_service/cmab/cmab_client";
import { DefaultCmabService } from "./core/decision_service/cmab/cmab_service";
import { InMemoryLruCache } from "./utils/cache/in_memory_lru_cache";
import { transformCache } from "./utils/cache/cache";
import { ConstantBackoff } from "./utils/repeater/repeater";
export const getOptimizelyInstance = (config) => {
    var _a, _b;
    const { clientEngine, clientVersion, jsonSchemaValidator, userProfileService, userProfileServiceAsync, defaultDecideOptions, disposable, requestHandler, } = config;
    const projectConfigManager = extractConfigManager(config.projectConfigManager);
    const eventProcessor = extractEventProcessor(config.eventProcessor);
    const odpManager = extractOdpManager(config.odpManager);
    const vuidManager = extractVuidManager(config.vuidManager);
    const errorNotifier = extractErrorNotifier(config.errorNotifier);
    const logger = extractLogger(config.logger);
    const cmabClient = new DefaultCmabClient({
        requestHandler,
        retryConfig: {
            maxRetries: DEFAULT_CMAB_RETRIES,
            backoffProvider: () => new ConstantBackoff(DEFAULT_CMAB_BACKOFF_MS),
        },
        predictionEndpointTemplate: (_a = config.cmab) === null || _a === void 0 ? void 0 : _a.predictionEndpointTemplate,
    });
    const cmabCache = ((_b = config.cmab) === null || _b === void 0 ? void 0 : _b.cache) ?
        transformCache(config.cmab.cache, (value) => JSON.parse(value), (value) => JSON.stringify(value)) :
        (() => {
            var _a, _b;
            const cacheSize = ((_a = config.cmab) === null || _a === void 0 ? void 0 : _a.cacheSize) || DEFAULT_CMAB_CACHE_SIZE;
            const cacheTtl = ((_b = config.cmab) === null || _b === void 0 ? void 0 : _b.cacheTtl) || DEFAULT_CMAB_CACHE_TIMEOUT_MS;
            return new InMemoryLruCache(cacheSize, cacheTtl);
        })();
    const cmabService = new DefaultCmabService({
        cmabClient,
        cmabCache,
        logger: logger === null || logger === void 0 ? void 0 : logger.child()
    });
    const optimizelyOptions = {
        cmabService,
        clientEngine: clientEngine || JAVASCRIPT_CLIENT_ENGINE,
        clientVersion: clientVersion || CLIENT_VERSION,
        jsonSchemaValidator,
        userProfileService,
        userProfileServiceAsync,
        defaultDecideOptions,
        disposable,
        logger,
        errorNotifier,
        projectConfigManager,
        eventProcessor,
        odpManager,
        vuidManager,
        // UNSTABLE_conditionEvaluators is not exposed in the public types, but we want to pass it through
        // for internal use cases.
        UNSTABLE_conditionEvaluators: config.UNSTABLE_conditionEvaluators,
    };
    return new Optimizely(optimizelyOptions);
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=client_factory.js.map